import React, { useState, useEffect } from 'react'

import { Link } from 'react-scroll';
import { GiHamburgerMenu } from 'react-icons/gi'

import '../styles/Nav.css'




const Nav = () => {
  const [isOpen, setIsOpen] = useState(true)

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  const [imageUrl, setImageUrl] = useState("https://spotify-github-profile.kittinanx.com/api/view.svg?uid=31hgv3hncqa5p4qme3hi7ll7nyeu&cover_image=true&theme=natemoo-re&show_offline=true&background_color=121212&interchange=true&bar_color_cover=false");

  useEffect(() => {
    const interval = setInterval(() => {
      setImageUrl(imageUrl + "?timestamp=" + new Date().getTime());
    }, 20000);
    return () => clearInterval(interval);
  }, [imageUrl]);

  const nav =
    <ul style={{ pointerEvents: 'auto' }}>
      <li><Link onClick={handleClick} activeClass="active" to="projects" spy={true} smooth={true} offset={-200} duration={500}>
        Projects
      </Link></li>
      <li><Link onClick={handleClick} activeClass="active" to="socials" spy={true} smooth={true} offset={-200} duration={500}>
        Socials
      </Link></li>
      <li><Link onClick={handleClick} activeClass="active" to="about" spy={true} smooth={true} offset={-100} duration={500}>
        About
      </Link></li>
      <li><Link onClick={handleClick} activeClass="active" to="skills" spy={true} smooth={true} offset={-150} duration={500}>
        Skills
      </Link></li>
      <li><Link onClick={handleClick} activeClass="active" to="mail" spy={true} smooth={true} offset={0} duration={500}>
        Contact
      </Link></li>
    </ul>

  return (
    <div className='nav'>
      <div className='header'>
        <h1>
          <Link activeClass="active" to="home" spy={true} smooth={true} offset={-80} duration={500}>
            <div>
              <img src="https://i.ibb.co/rmV3jyF/Picsart-23-04-23-16-38-56-694.png" className='kslogo' alt="Logo" border="0" height="56" width="56" />
            </div>
          </Link>
        </h1>
        <div onClick={handleClick} className="menu">
          <GiHamburgerMenu />
        </div>
        <div className='large' >
          {nav}
        </div>
      </div>
      <div className='small' onClick={handleClick} style={{
        display: isOpen ? 'none' : 'flex'
      }}>
        {nav}
        <div className='spotifynav'>
          <a href="https://spotify-github-profile.kittinanx.com/api/view.svg?uid=31hgv3hncqa5p4qme3hi7ll7nyeu&redirect=true">
            <img src={imageUrl} alt="Spotify" align="center" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Nav;

